import { IResponseProcessor } from "..";
import { IProduct } from "../product/ProductsApi";
import { IResellerInfo } from "../reseller/ResellersApi";

interface ICreateOpportunityInput {
  BidNumber: string;
  BidTitle: string;
  StartDate: string;
  EndDate: string;
  QuoteOnly: boolean;
  Description: string;
  DefaultResellers: string;
}

interface IRenewOpportunityInput {
  BidNumber: string;
  BidTitle: string;
  StartDate: string;
  EndDate: string;
  QuoteOnly: boolean;
}

export default class OpportunitiesApi {
  constructor(
    private _baseUrl: string,
    private _getToken: (applicationId: string) => string,
    private _processor: IResponseProcessor
  ) {
    console.warn(
      "Deprecation Warning: The legacy 'OpportunitiesApi' class is in use. Please migrate to RTK Query hooks from 'randmar-api-client' as described in CONTRIBUTING.md."
    );
  }

  /**
   * @deprecated Use `useGetV4ManufacturerByRouteManufacturerIdOpportunitiesQuery` instead.
   */
  async retrieveOpportunities(applicationId: string): Promise<IOpportunity[]> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunities`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);
    const opportunities: IOpportunity[] = await res.json();

    return opportunities;
  }

  /**
   * @deprecated Use `useGetV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberQuery` instead.
   */
  async getOpportunity(applicationId: string, bidNumber: string, withSpecification: boolean): Promise<IOpportunity> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}?withSpecification=${withSpecification}`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);
    const opportunity: IOpportunity = await res.json();

    return opportunity;
  }

  /**
   * @deprecated Use `usePutV4ManufacturerByRouteManufacturerIdOpportunityMutation` instead.
   */
  async addOpportunity(applicationId: string, bidNumber: string, bidTitle: string, description: string, defaultResellers: string, startDate: string, endDate: string, quoteOnly: boolean): Promise<boolean> {
    const opportunityData: ICreateOpportunityInput = {
      BidNumber: bidNumber,
      BidTitle: bidTitle,
      StartDate: startDate,
      EndDate: endDate,
      QuoteOnly: quoteOnly,
      Description: description,
      DefaultResellers: defaultResellers
    };
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${this._getToken(applicationId)}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(opportunityData)
    });

    this._processor.process(res);

    return await res.json();
  }

  /**
   * @deprecated Use `usePutV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberMutation` instead.
   */
  async renewOpportunity(applicationId: string, bidNumber: string, newBidNumber: string, newBidTitle: string, newStartDate: string, newEndDate: string, quoteOnly: boolean): Promise<boolean> {
    const renewData: IRenewOpportunityInput = {
      BidNumber: newBidNumber,
      BidTitle: newBidTitle,
      StartDate: newStartDate,
      EndDate: newEndDate,
      QuoteOnly: quoteOnly
    };
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${this._getToken(applicationId)}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(renewData)
    });

    this._processor.process(res);

    return await res.json();
  }

  /**
   * @deprecated Use `usePutV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberResellerResellerIdMutation` instead.
   */
  async addResellerToOpportunity(applicationId: string, bidNumber: string, resellerId: string): Promise<boolean> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}/Reseller/${resellerId}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    return await res.json();
  }

  /**
   * @deprecated Use `useDeleteV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberResellerResellerIdMutation` instead.
   */
  async removeResellerFromOpportunity(applicationId: string, bidNumber: string, resellerId: string): Promise<boolean> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}/Reseller/${resellerId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    return await res.json();
  }

  /**
   * @deprecated Use `usePostV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberPartNumberRandmarSkuMutation` instead.
   */
  async addProductToOpportunity(applicationId: string, bidNumber: string, randmarSKU: string, bidPrice: number, bidPriceType: string): Promise<boolean> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}/PartNumber/${randmarSKU}?bidPrice=${bidPrice}&bidPriceType=${bidPriceType}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    return await res.json();
  }


  /**
   * @deprecated Use `useDeleteV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberPartNumberRandmarSkuMutation` instead.
   */
  async deleteProductFromOpportunity(applicationId: string, bidNumber: string, randmarSKU: string) {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}/PartNumber/${randmarSKU}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    return await res.json();
  }

  /**
   * @deprecated Use `usePostV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberFieldNameMutation` instead.
   */
  async editOpportunity(applicationId: string, bidNumber: string, fieldId: string, newValue: string): Promise<boolean> {
    const res = await fetch(`${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}/${fieldId}?newValue=${encodeURIComponent(newValue)}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });
    this._processor.process(res);

    return res.json();
  }

  /**
   * @deprecated Use `useDeleteV4ManufacturerByRouteManufacturerIdOpportunityAndBidNumberMutation` instead.
   */
  async deleteOpportunity(applicationId: string, bidNumber: string): Promise<boolean> {

    const res = await fetch(`${this._baseUrl}/${applicationId}/Opportunity/${bidNumber}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });
    this._processor.process(res);

    return await res.json();
  }
}

export interface IOpportunity {
  BidNumber: string;
  Opportunity: string;
  Description: string;
  StartDate: string;
  EndDate: string;
  LastUpdate: string;
  Active: boolean;
  ManufacturerId: string;
  DefaultResellers: string;
  CanBeSetAsDefault: boolean;
  BidPrice: number;
  BidPriceType: string;
  RandmarSKU: string;

  Resellers: IResellerInfo[];
  Details: IOpportunityDetail[];
}

export interface IOpportunityDetail {
  BidNumber: string;
  BidPrice: number;
  BidPriceType: string;
  Product: IProduct;
  RandmarSKU: string;
}
